import CONFIG from '../config';

export const SELECTORS = ', .pt_content #primary'
export const TABLET_BREAKPOINT = '1280px';
export const MIN_PRICE_BANNER_SIZE = '850px';
export const MOBILE_BREAKPOINT = '720px';

export const PROMOTION_YELLOW = '#E6BC07';

//Font management
export const UBISOFT_FONT = '\'Ubisoft Sans Regular\',arial,sans-serif'
export const UBISOFT_BOLD_FONT = '\'Ubisoft Sans Bold\',arial,sans-serif'
export const UBUNTU_FONT = '\'Ubuntu\',\'Ubisoft Sans Regular\',sans-serif'
